<template>
  <div>
    <v-data-table :headers="headers" fixed-header :loading="loading" no-results-text="Nenhum registro encontrado"
                  loading-text="Carregando" class="elevation-1" :server-items-length="totalItems"
                  :options.sync="options"
                  :footer-props="{
                showFirstLastPage: true,
                itemsPerPageOptions: [10, 15, 30, 50],
                itemsPerPageText: 'Itens por página',
                showCurrentPage: true,
            }" :items="prepareData(items.data)">

      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>
            <v-icon>mdi-send</v-icon>
            Campanhas
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>

          <v-row class="justify-space-between">
            <v-btn color="green" dark to="/campanhas/novo">
              <v-icon left>
                mdi-plus
              </v-icon>
              Nova Campanha
            </v-btn>
            
            <v-btn class="" @click="dialogFilters = true">
              <v-icon left>
                mdi-filter
              </v-icon>
              <span>Filtrar</span>
            </v-btn>
            
            <v-text-field v-model="search" @keyup.enter="searchText" append-icon="mdi-magnify" style="max-width: 400px"
                          label="Buscar (Enter para Buscar)" single-line hide-details></v-text-field>
          </v-row>
        </v-toolbar>
      </template>

      <template v-slot:item.stopped="{ item }">
        <v-chip :color="getColor(item)" dark>
          {{ getTextEnabled(item) }}
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom v-if="item.manual">
          <template v-slot:activator="{ on, attrs }">
            <v-icon medium :disabled="getSendingStatus(item) || item.stopped === 1" class="mr-2"
                    color="green darken-2" @click="shoot(item)" v-bind="attrs" v-on="on">
              mdi-send
            </v-icon>
          </template>
          <span>Disparo Avulso </span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.stopped === 1">
          <template v-slot:activator="{ on, attrs }">
            <v-icon medium :disabled="getSendingStatus(item)" class="mr-2" color="green"
                    @click="changeStopped(item.id, 0)" v-bind="attrs" v-on="on">
              mdi-play
            </v-icon>
          </template>
          <span>Continar Campanha</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.stopped === 0">
          <template v-slot:activator="{ on, attrs }">
            <v-icon medium :disabled="getSendingStatus(item)" class="mr-2" color="orange"
                    @click="changeStopped(item.id, 1)" v-bind="attrs" v-on="on">
              mdi-pause
            </v-icon>
          </template>
          <span>Pausar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon medium class="mr-2" color="blue darken-4" @click="report(item)" v-bind="attrs"
                    v-on="on">
              mdi-file
            </v-icon>
          </template>
          <span>Relatorio da Campanha</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon medium :disabled="getSendingStatus(item)" class="mr-2" color="blue"
                    @click="editItem(item)" v-bind="attrs" v-on="on">
              mdi-pencil
            </v-icon>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon :disabled="getSendingStatus(item)" medium @click="deleteItem(item)" color="red"
                    v-bind="attrs" v-on="on">
              mdi-delete
            </v-icon>
          </template>
          <span>Deletar</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <DialogDelete message="Deseja realmente deletar essa Campanha?" :dialog="dialogDelete"
                  :confirmDialog="handleConfirmDelete" :cancelDialog="handleCancelDelete"/>

    <DialogConfirm message="Confirma o envio dessa Campanha?" :dialog="dialogConfirmModal"
                   :confirmDialog="handleConfirmCampaign" :cancelDialog="handleCancelCampaign"/>

    <template>
      <v-dialog v-model="dialogFilters" width="500">
        <v-card>
          <v-card-title>
            <h4>Filtros</h4>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-select :items="status" v-model="filterSelected" item-text="text"
                            item-value="value" clearable label="Status" outlined></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="clearFilters">
              Limpar Filtros
            </v-btn>
            <v-btn color="primary" text @click="handleFilter">
              Filtrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>
<script>
import {mapMutations, mapState} from "vuex";
import DialogDelete from "@/components/DialogDelete";
import DialogConfirm from "@/components/DialogConfirm";
import api from '@/api/campaign';

export default {
  name: "CampaignList",
  components: {
    DialogDelete,
    DialogConfirm,
  },
  data: () => ({
    search: '',
    loading: false,
    headers: [
      {text: 'ID', align: 'end', value: 'id'},
      {text: 'Titulo', value: 'title'},
      {text: 'Tipo', value: 'type'},
      {text: 'Assunto', value: 'subject'},
      {text: 'Status', value: 'stopped'},
      {text: 'Tipo de Envio', value: 'type_send'},
      {text: 'Próximo Envio', value: 'next_send'},
      {text: "Data de Criação", value: "created_at"},
      {text: "Data de Atualização", value: "updated_at"},
      {text: "Ações", value: "actions", align: 'end', sortable: false, width: 200}
    ],
    options: {
      page: 1,
      search: '',
    },
    filters: {
      stopped: null,
      disabled: null,
    },
    items: {
      data: [],
    },
    totalItems: 0,
    itemShow: [],
    dialogDelete: false,
    _itemDelete: {},
    dialogConfirmModal: false,
    _itemConfirm: {},
    dialogFilters: false,
    filterSelected: '',
    status: [
      {value: '', text: 'Todos'},
      {value: 'inactive', text: 'Inativas'},
      {value: 'paused', text: 'Pausadas'},
    ],
  }),
  created() {
    this.initialize();
  },
  computed: {
    ...mapState({
      companySelected: state => state.companySelected
    })
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: false,
    },
  },
  methods: {
    ...mapMutations(["showLoading", "hideLoading", "showAlert", "setDrawer",]),
    async initialize() {
      this.setDrawer(false);
    },
    async getData() {
      this.showLoading();
      this.items = [];

      let options = this.options;
      let filters = this.filters;

      options = {...options, ...filters};

      try {
        let response = await api.get(options);
        this.items = response.data;
        this.totalItems = response.data.total;
      } catch (error) {
        this.items = [];
        this.showAlert({message: error.message, type: "error"});
      } finally {
        this.hideLoading();
        this.loading = false;
      }
    },
    getColor(item) {
      if (item.stopped === 1) {
        return 'orange';
      } else if (item.sending !== null && Object.keys(item.sending).length > 0) {
        return 'blue';
      } else {
        return 'green';
      }
    },
    getTextEnabled(item) {
      if (item.stopped === 1) {
        return 'Pausada';
      } else if (item.sending !== null && Object.keys(item.sending).length > 0) {
        return 'Enviando';
      } else {
        return 'Ativa';
      }
    },
    prepareData(data) {
      if (data == undefined)
        return [];

      return data.map(item => {
        return {
          ...item,
          manual: item.type_send == 'manual' ? true : false,
          type_send: this.typeSend(item.type_send),
          next_send: item.next_send != null ? this.dateToBr(item.next_send) : '--/--/----',
          created_at: this.dateToBr(item.created_at, false),
          updated_at: this.dateToBr(item.updated_at, false)
        };
      });
    },
    dateToBr(date, type = true) {
      if (!date) return date;
      let [fullDate, minutes] = date.split(" ");
      if (type) {
        return `${fullDate
          .split("-")
          .reverse()
          .join("/") + ' ' + minutes}`;
      } else {
        return `${fullDate
          .split("-")
          .reverse()
          .join("/")}`;
      }
    },
    typeSend(name) {
      if (name == 'unique')
        return 'Único';
      else if (name == 'recurrence')
        return 'Recorrente';

      return 'Manual';
    },
    editItem(item) {
      this.$router.push(`/campanhas/${item.id}/editar`);
    },
    report(item) {
      this.$router.push(`/campanhas/${item.id}/detalhes`);
    },
    deleteItem(item) {
      this.dialogDelete = true;
      this._itemDelete = item;
    },
    async handleConfirmDelete() {
      this.dialogDelete = false;
      this.showLoading();

      try {
        let res = await api.destroy(this._itemDelete.id);
        this.showAlert({
          message: "Modelo de Email deletado com sucesso",
          type: "success",
        });
        this.options.page;
        this.getData();
      } catch (error) {
        if (error.response.status === 400) {
          this.showAlert({
            message: error.response.data.message,
            type: "error",
          });
        } else {
          this.showAlert({
            message: error.message,
            type: "error",
          });
        }
      } finally {
        this._itemDelete = {};
        this.hideLoading();
      }
    },
    handleCancelDelete() {
      this.dialogDelete = false;
      this._itemDelete = {};
    },
    async changeStopped(id, stopped) {
      this.showLoading();
      try {
        let res = await api.updateStopped(id, {stopped: stopped});
        if (res) {
          this.showAlert({
            message: "Campanha Atualizada com sucesso",
            type: "success",
          });
          this.getData();
        }
      } catch (error) {
        this.showAlert({message: error.message, type: "error"});
      } finally {
        this.hideLoading();
      }
    },
    async reactiveItem(item) {
      this.showLoading();
      try {
        let res = await api.reactive(item.id);
        if (res) {
          this.showAlert({
            message: "Campanha Reativada com sucesso",
            type: "success",
          });
          this.tabActive = 1;
          this.getData();
        }
      } catch (error) {
        this.showAlert({message: error.message, type: "error"});
      } finally {
        this.hideLoading();
      }
    },
    shoot(item) {
      this.dialogConfirmModal = true;
      this._itemConfirm = item;
    },
    async handleConfirmCampaign() {
      this.showLoading();
      const id = this._itemConfirm.id;
      this._itemConfirm = {};
      this.dialogConfirmModal = false;
      try {
        let res = await api.shoot(id);

        if (res) {
          this.showAlert({
            message: "Campanha Disparada com sucesso",
            type: "success",
          });
        }
      } catch (error) {
        this.showAlert({message: error.message, type: "error"});
      } finally {
        this.hideLoading();
      }
    },
    handleCancelCampaign() {
      this.dialogConfirmModal = false;
      this._itemConfirm = {};
    },
    getSendingStatus(item) {
      return (item.sending !== null && Object.keys(item.sending).length > 0) ? true : false;
    },
    searchText() {
      if (this.search != '') {
        this.options.search = this.search;
        this.getData();
      } else {
        this.options.search = '';
        this.getData();
      }
    },
    clearFilters() {
      this.filters.stopped = null;
      this.filters.disabled = null;

      this.filterSelected = '';
      this.dialogFilters = false;

      this.getData();
    },
    handleFilter() {
      this.filters.stopped = null;
      this.filters.disabled = null;

      if (this.filterSelected != '') {
        switch (this.filterSelected) {
          case 'inactive':
            this.filters.disabled = true;
            break;
          case 'paused':
            this.filters.stopped = true;
            break;
        }
      }

      this.getData();
      this.dialogFilters = false;
    }
  }
};
</script>
